module.exports = __webpack_public_path__ + "static/media/login.1104ba96.png";